import React from 'react'

export const IconExclamation = () => (
  <svg
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M42.4333 0H17.5667L0 17.5667V42.4333L17.5667 60H42.4333L60 42.4333V17.5667L42.4333 0ZM53.3333 39.6667L39.6667 53.3333H20.3333L6.66667 39.6667V20.3333L20.3333 6.66667H39.6667L53.3333 20.3333V39.6667Z"
      fill="var(--flora--colors-alert-standard)"
    />
    <path
      d="M30 46.6667C31.8409 46.6667 33.3333 45.1743 33.3333 43.3333C33.3333 41.4924 31.8409 40 30 40C28.159 40 26.6667 41.4924 26.6667 43.3333C26.6667 45.1743 28.159 46.6667 30 46.6667Z"
      fill="var(--flora--colors-alert-standard)"
    />
    <path
      d="M26.6667 13.3333H33.3333V36.6667H26.6667V13.3333Z"
      fill="var(--flora--colors-alert-standard)"
    />
  </svg>
)
